export const defaultUiSchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#"
    }
  ]
};
